/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehousePackageSummaryDTO interface.
 */
export function instanceOfWarehousePackageSummaryDTO(value) {
    return true;
}
export function WarehousePackageSummaryDTOFromJSON(json) {
    return WarehousePackageSummaryDTOFromJSONTyped(json, false);
}
export function WarehousePackageSummaryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pendingCount': json['pendingCount'] == null ? undefined : json['pendingCount'],
        'receivedCount': json['receivedCount'] == null ? undefined : json['receivedCount'],
        'shippedCount': json['shippedCount'] == null ? undefined : json['shippedCount'],
        'awaitingReceiptCount': json['awaitingReceiptCount'] == null ? undefined : json['awaitingReceiptCount'],
        'supplierDelayedCount': json['supplierDelayedCount'] == null ? undefined : json['supplierDelayedCount'],
        'supplierNotArrivingCount': json['supplierNotArrivingCount'] == null ? undefined : json['supplierNotArrivingCount'],
    };
}
export function WarehousePackageSummaryDTOToJSON(json) {
    return WarehousePackageSummaryDTOToJSONTyped(json, false);
}
export function WarehousePackageSummaryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pendingCount': value['pendingCount'],
        'receivedCount': value['receivedCount'],
        'shippedCount': value['shippedCount'],
        'awaitingReceiptCount': value['awaitingReceiptCount'],
        'supplierDelayedCount': value['supplierDelayedCount'],
        'supplierNotArrivingCount': value['supplierNotArrivingCount'],
    };
}
